"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var dom_interact_1 = require("../helpers/dom-interact");
var AbstractSlider_1 = __importDefault(require("./AbstractSlider"));
var DeviceManager_1 = require("./DeviceManager");
var ProductImagesSlider = /** @class */ (function (_super) {
    __extends(ProductImagesSlider, _super);
    function ProductImagesSlider(props) {
        var _this = _super.call(this, props.el) || this;
        _this.isMobile = false;
        var changeMainImageEvent = props.el.dataset.changeMainImageEvent || 'click';
        _this.handleSlideChange = _this.handleSlideChange.bind(_this);
        _this.customEvents = [
            {
                name: changeMainImageEvent,
                queries: [AbstractSlider_1.default.SLIDER_ITEMS_SELECTOR],
                callback: _this.handleSlideChange,
            },
            {
                name: 'click',
                queries: [ProductImagesSlider.DOTS_SELECTOR],
                callback: _this.handleSlideChange,
            },
            {
                name: 'click',
                queries: [ProductImagesSlider.PREV_BUTTON_SELECTOR_MOBILE],
                callback: _this.onMobilePrevClick.bind(_this),
            },
            {
                name: 'click',
                queries: [ProductImagesSlider.NEXT_BUTTON_SELECTOR_MOBILE],
                callback: _this.onMobileNextClick.bind(_this),
            },
        ];
        _this.mainImage = props.parentElement.querySelector(ProductImagesSlider.MAIN_IMAGE_SELECTOR);
        _this.mainImageSource = props.parentElement.querySelector(ProductImagesSlider.MAIN_IMAGE_SOURCE_SELECTOR);
        _this.mainImageOverlay = props.parentElement.querySelector(ProductImagesSlider.MAIN_OVERLAY_IMAGE_SELECTOR);
        _this.galleryImageOverlay = props.parentElement.querySelector(ProductImagesSlider.GALLERY_OVERLAY_IMAGE_SELECTOR);
        _this.dots = Array.from(props.el.querySelectorAll(ProductImagesSlider.DOTS_SELECTOR));
        _this.prevBtn = (0, dom_interact_1.getHTMLElement)(props.el, AbstractSlider_1.default.PREV_BUTTON_SELECTOR);
        _this.nextBtn = (0, dom_interact_1.getHTMLElement)(props.el, AbstractSlider_1.default.NEXT_BUTTON_SELECTOR);
        _this.prevMobileBtn = (0, dom_interact_1.getHTMLElement)(props.el, ProductImagesSlider.PREV_BUTTON_SELECTOR_MOBILE);
        _this.nextMobileBtn = (0, dom_interact_1.getHTMLElement)(props.el, ProductImagesSlider.NEXT_BUTTON_SELECTOR_MOBILE);
        _this.deviceManager = new DeviceManager_1.DeviceManager();
        _this.config = __assign({ duration: 200 }, props);
        _this.prevBtn.classList.add(ProductImagesSlider.DISABLED_CLASSNAME);
        _this.updateDotsHiddenState();
        _this.updateMobileNavigationHiddenState();
        setTimeout(function () {
            _this.init(_this.config);
        }, 0);
        return _this;
    }
    ProductImagesSlider.prototype.handleSlideChange = function (e) {
        var target = e.currentTarget;
        var nextSlideId = this.getElementSlideId(target);
        if (nextSlideId === this.activeSlideId) {
            return;
        }
        this.setActiveState(nextSlideId);
        if (this.isMobile) {
            this.handleMobileSlideChange();
        }
    };
    ProductImagesSlider.prototype.handleMobileSlideChange = function () {
        var _this = this;
        var goToSlideIndex = this.allNotHiddenElements(this.slideItems).findIndex(function (slide) { return _this.getElementSlideId(slide) === _this.activeSlideId; });
        this.goTo(goToSlideIndex);
    };
    ProductImagesSlider.prototype.changeMainImage = function (slideElement) {
        if (this.mainImage === null) {
            throw new Error('Main image does not exists');
        }
        var image = (0, dom_interact_1.getHTMLElement)(slideElement, 'img');
        var srcAttribute = image.getAttribute('src') || '';
        var srcSetAttribute = image.getAttribute('srcset') || '';
        this.mainImage.setAttribute('src', srcAttribute);
        if (this.mainImageSource) {
            this.mainImageSource.setAttribute('srcset', srcSetAttribute);
        }
    };
    ProductImagesSlider.prototype.updateMainImageOverlayHiddenState = function (slideElement) {
        if (!this.mainImageOverlay || !this.galleryImageOverlay) {
            return;
        }
        if (slideElement.contains(this.galleryImageOverlay)) {
            this.mainImageOverlay.setAttribute('src', this.galleryImageOverlay.getAttribute('src') || '');
            this.mainImageOverlay.classList.remove(ProductImagesSlider.HIDDEN_CLASSNAME);
        }
        else {
            this.mainImageOverlay.classList.add(ProductImagesSlider.HIDDEN_CLASSNAME);
            this.mainImageOverlay.setAttribute('src', '');
        }
    };
    ProductImagesSlider.prototype.onFormatChange = function (format) {
        this.updateFormatSlidesHiddenState(format);
        this.updateDotsHiddenState();
        this.updateMobileNavigationHiddenState();
        this.totalItems = this.getTotalItems();
        var notHiddenSlides = this.allNotHiddenElements(this.slideItems);
        var nextSlideId = notHiddenSlides[0] && this.getElementSlideId(notHiddenSlides[0]);
        if (nextSlideId || nextSlideId === 0) {
            this.setActiveState(nextSlideId);
        }
        this.setViewportSize();
    };
    ProductImagesSlider.prototype.onInnerPagesOptionChange = function (format, innerPagesSKU, options) {
        this.updateFormatSlidesHiddenState(format);
        this.updateInnerPagesSlidesHiddenState(innerPagesSKU);
        this.updateDotsHiddenState();
        this.updateMobileNavigationHiddenState();
        this.totalItems = this.getTotalItems();
        this.showOrHideInnerPagesNote(innerPagesSKU);
        var notHiddenSlides = this.allNotHiddenElements(this.slideItems).filter(function (element) {
            var image = element.querySelector('img');
            var imageSrc = image === null || image === void 0 ? void 0 : image.src;
            return imageSrc === null || imageSrc === void 0 ? void 0 : imageSrc.includes(innerPagesSKU);
        });
        var nextSlideId = notHiddenSlides[0] && this.getElementSlideId(notHiddenSlides[0]);
        if ((options === null || options === void 0 ? void 0 : options.setActive) && (nextSlideId || nextSlideId === 0)) {
            this.setActiveState(nextSlideId);
            if (this.isMobile) {
                // This is required in order to slide-in the needed slide on mobile.
                // On higher resolutions we have the "main image" that gets changed instead of the slider position.
                this.handleMobileSlideChange();
            }
        }
        this.setViewportSize();
    };
    ProductImagesSlider.prototype.updateInnerPagesSlidesHiddenState = function (innerPagesSKU) {
        var skipInitialSlideItems = this.allNotHiddenElements(this.slideItems);
        skipInitialSlideItems.forEach(function (slide) {
            var image = slide.querySelector('img');
            var imageSrc = image === null || image === void 0 ? void 0 : image.src;
            if (image) {
                if (imageSrc === null || imageSrc === void 0 ? void 0 : imageSrc.includes('IN')) {
                    // Hide all the innerPages images first.
                    slide.classList.add(ProductImagesSlider.HIDDEN_CLASSNAME);
                }
                if (imageSrc === null || imageSrc === void 0 ? void 0 : imageSrc.includes(innerPagesSKU)) {
                    // Only show the one we need for the current SKU and format.
                    slide.classList.remove(ProductImagesSlider.HIDDEN_CLASSNAME);
                }
            }
        });
    };
    ProductImagesSlider.prototype.updateOverlayImagesOnFormatColorChange = function (format, color, productJSON) {
        var _this = this;
        var product = productJSON.concreteProducts.find(function (concreteProduct) { return concreteProduct.format === format; });
        var overlayImageUrl = product && product.overlayImages && product.overlayImages[color];
        var activeSlide = this.slideItems.find(function (slide) { return _this.getElementSlideId(slide) === _this.activeSlideId; });
        this.updateGalleryImageOverlay(overlayImageUrl);
        if (activeSlide) {
            this.updateMainImageOverlayHiddenState(activeSlide);
        }
    };
    ProductImagesSlider.prototype.updateGalleryImageOverlay = function (overlayImageUrl) {
        if (!this.galleryImageOverlay) {
            return;
        }
        if (overlayImageUrl) {
            this.galleryImageOverlay.setAttribute('src', overlayImageUrl);
            this.galleryImageOverlay.classList.remove(ProductImagesSlider.HIDDEN_CLASSNAME);
        }
        else {
            this.galleryImageOverlay.classList.add(ProductImagesSlider.HIDDEN_CLASSNAME);
            this.galleryImageOverlay.setAttribute('src', '');
        }
    };
    ProductImagesSlider.prototype.showOrHideInnerPagesNote = function (selectedOption) {
        if (!selectedOption) {
            return;
        }
        var innerPagesTextGeneral = document.querySelectorAll(ProductImagesSlider.INNERPAGES_NOTE_TEXT_GENERAL);
        var innerPagesTextDesigned = document.querySelectorAll(ProductImagesSlider.INNERPAGES_NOTE_TEXT_DESIGNED);
        var toggleVisibility = function (elements, condition) {
            elements.forEach(function (element) {
                element.classList.toggle('hide', !condition);
            });
        };
        toggleVisibility(innerPagesTextDesigned, selectedOption === 'IN03');
        toggleVisibility(innerPagesTextGeneral, selectedOption !== 'undefined');
    };
    ProductImagesSlider.prototype.updateFormatSlidesHiddenState = function (format) {
        var _this = this;
        this.slideItems.forEach(function (slide) {
            var _a = slide.dataset.formats, formats = _a === void 0 ? '' : _a;
            if (formats.includes(format)) {
                slide.classList.remove(ProductImagesSlider.HIDDEN_CLASSNAME);
            }
            else {
                slide.classList.add(ProductImagesSlider.HIDDEN_CLASSNAME);
            }
            if (!slide.classList.contains(ProductImagesSlider.HIDDEN_CLASSNAME)) {
                _this.setImageUrl(slide.querySelector('img'));
            }
        });
    };
    ProductImagesSlider.prototype.updateDotsHiddenState = function () {
        var _this = this;
        this.dots.forEach(function (dot) {
            var slideId = _this.getElementSlideId(dot);
            var findRelatedSlide = _this.slideItems.find(function (slide) { return _this.getElementSlideId(slide) === slideId; });
            if (findRelatedSlide) {
                if (findRelatedSlide.classList.contains(ProductImagesSlider.HIDDEN_CLASSNAME)) {
                    dot.classList.add(ProductImagesSlider.HIDDEN_CLASSNAME);
                }
                else {
                    dot.classList.remove(ProductImagesSlider.HIDDEN_CLASSNAME);
                }
            }
        });
        var notHiddenDots = this.allNotHiddenElements(this.dots);
        if (notHiddenDots.length === 1) {
            notHiddenDots[0].classList.add(ProductImagesSlider.HIDDEN_CLASSNAME);
        }
    };
    ProductImagesSlider.prototype.updateMobileNavigationHiddenState = function () {
        if (this.allNotHiddenElements(this.slideItems).length === 1) {
            this.prevMobileBtn.classList.add(ProductImagesSlider.HIDDEN_CLASSNAME);
            this.nextMobileBtn.classList.add(ProductImagesSlider.HIDDEN_CLASSNAME);
        }
        else {
            this.prevMobileBtn.classList.remove(ProductImagesSlider.HIDDEN_CLASSNAME);
            this.nextMobileBtn.classList.remove(ProductImagesSlider.HIDDEN_CLASSNAME);
        }
    };
    ProductImagesSlider.prototype.selectPrevSlide = function () {
        if (!this.canBeSlided) {
            return;
        }
        var prevSlideId = this.getSlideSiblings().prevSlideId;
        this.setActiveState(prevSlideId);
    };
    ProductImagesSlider.prototype.selectNextSlide = function () {
        if (!this.canBeSlided) {
            return;
        }
        var nextSlideId = this.getSlideSiblings().nextSlideId;
        this.setActiveState(nextSlideId);
    };
    ProductImagesSlider.prototype.handleSwipeEvents = function (e) {
        if (this.isAnimated || this.deviceManager.getCurrentState() !== DeviceManager_1.MOBILE || !this.canBeSlided) {
            return;
        }
        if (e.type === 'swiperight') {
            this.selectPrevSlide();
        }
        else if (e.type === 'swipeleft') {
            this.selectNextSlide();
        }
        this.handleMobileSlideChange();
    };
    ProductImagesSlider.prototype.onPrevClick = function () {
        if (this.isAnimated || this.scrolledItems === 0) {
            return;
        }
        var scrollItemsAmount = this.isMobile ? 1 : this.visibleSliderItems - 1;
        if (this.scrolledItems <= scrollItemsAmount) {
            this.scrolledItems = 0;
            this.prevBtn.classList.add(ProductImagesSlider.DISABLED_CLASSNAME);
        }
        else {
            this.scrolledItems -= scrollItemsAmount;
        }
        this.nextBtn.classList.remove(ProductImagesSlider.DISABLED_CLASSNAME);
        this.animateGallery();
    };
    ProductImagesSlider.prototype.onMobilePrevClick = function (event) {
        event.preventDefault();
        this.selectPrevSlide();
        this.handleMobileSlideChange();
    };
    ProductImagesSlider.prototype.onNextClick = function () {
        var maxPossibleScrollPosition = this.totalItems - this.visibleSliderItems;
        if (this.isAnimated || this.scrolledItems === maxPossibleScrollPosition) {
            return;
        }
        var scrollItemsAmount = this.isMobile ? 1 : this.visibleSliderItems - 1;
        if (this.scrolledItems >= maxPossibleScrollPosition - scrollItemsAmount) {
            this.scrolledItems = maxPossibleScrollPosition;
            this.nextBtn.classList.add(ProductImagesSlider.DISABLED_CLASSNAME);
        }
        else {
            this.scrolledItems += scrollItemsAmount;
        }
        this.prevBtn.classList.remove(ProductImagesSlider.DISABLED_CLASSNAME);
        this.animateGallery();
    };
    ProductImagesSlider.prototype.onMobileNextClick = function (event) {
        event.preventDefault();
        this.selectNextSlide();
        this.handleMobileSlideChange();
    };
    ProductImagesSlider.prototype.setViewportSize = function () {
        this.visibleSliderItems = this.getSliderSize();
        var visibleSliderItems = this.visibleSliderItems + (this.deviceManager.getCurrentState() === DeviceManager_1.WIDE_DESKTOP ? 0 : 1);
        if (visibleSliderItems >= this.totalItems) {
            this.el.classList.remove('navigation-visible');
            this.scrolledItems = 0;
            this.updateSliderPosition(0);
            this.frameSize = 0;
            return true;
        }
        this.el.classList.add('navigation-visible');
        if (this.scrolledItems > 0 || this.isMobile) {
            this.prevBtn.classList.remove(ProductImagesSlider.DISABLED_CLASSNAME);
        }
        else {
            this.prevBtn.classList.add(ProductImagesSlider.DISABLED_CLASSNAME);
        }
        if (this.scrolledItems < this.totalItems - this.visibleSliderItems || this.isMobile) {
            this.nextBtn.classList.remove(ProductImagesSlider.DISABLED_CLASSNAME);
        }
        else {
            this.nextBtn.classList.add(ProductImagesSlider.DISABLED_CLASSNAME);
        }
        var lastVisibleItem = this.allNotHiddenElements(this.slideItems)[this.visibleSliderItems - 1];
        var lastVisibleItemPosition = this.isVertical ? lastVisibleItem.offsetTop : lastVisibleItem.offsetLeft;
        this.frameSize = this.tileSize + lastVisibleItemPosition;
        return true;
    };
    ProductImagesSlider.prototype.getSliderSize = function () {
        if (this.deviceManager.getCurrentState() === DeviceManager_1.MOBILE) {
            this.isMobile = true;
            return 1;
        }
        if (this.deviceManager.getCurrentState() <= DeviceManager_1.DESKTOP) {
            this.isMobile = false;
            return 3;
        }
        this.isMobile = false;
        return 4;
    };
    ProductImagesSlider.prototype.setActiveState = function (nextSlideId) {
        var _this = this;
        var nextActiveSlide = this.slideItems.find(function (slide) { return _this.getElementSlideId(slide) === nextSlideId; });
        this.activeSlideId = nextSlideId;
        this.updateSlidesActiveState(nextSlideId);
        this.updateDotsActiveState(nextSlideId);
        if (nextActiveSlide) {
            if (this.mainImage) {
                this.changeMainImage(nextActiveSlide);
            }
            this.updateMainImageOverlayHiddenState(nextActiveSlide);
        }
    };
    ProductImagesSlider.prototype.updateSlidesActiveState = function (nextSlideId) {
        var _this = this;
        this.slideItems.forEach(function (slide) {
            var slideId = _this.getElementSlideId(slide);
            if (slideId === nextSlideId) {
                slide.classList.add(ProductImagesSlider.ACTIVE_CLASSNAME);
            }
            else {
                slide.classList.remove(ProductImagesSlider.ACTIVE_CLASSNAME);
            }
        });
    };
    ProductImagesSlider.prototype.updateDotsActiveState = function (nextSlideId) {
        var _this = this;
        this.dots.forEach(function (slide) {
            var slideId = _this.getElementSlideId(slide);
            if (slideId === nextSlideId) {
                slide.classList.add(ProductImagesSlider.ACTIVE_CLASSNAME);
            }
            else {
                slide.classList.remove(ProductImagesSlider.ACTIVE_CLASSNAME);
            }
        });
    };
    ProductImagesSlider.prototype.updateSliderPosition = function (value) {
        if (this.isVertical && !this.isMobile) {
            this.slider.style.top = "-".concat(value, "px");
            this.slider.style.left = '';
        }
        else {
            this.slider.style.left = "-".concat(value, "px");
            this.slider.style.top = '';
        }
    };
    Object.defineProperty(ProductImagesSlider.prototype, "tileSize", {
        get: function () {
            var firstSlideItem = this.allNotHiddenElements(this.slideItems)[0];
            if (!firstSlideItem) {
                return 0;
            }
            return this.isVertical && !this.isMobile ? firstSlideItem.offsetHeight : firstSlideItem.offsetWidth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductImagesSlider.prototype, "frameSize", {
        get: function () {
            return this.isVertical && !this.isMobile ? this.frame.offsetHeight : this.frame.offsetWidth;
        },
        set: function (value) {
            var propertyValue = value === 0 ? '' : "".concat(value, "px");
            if (this.isVertical && !this.isMobile) {
                this.frame.style.height = propertyValue;
                this.frame.style.width = '';
            }
            else {
                this.frame.style.width = propertyValue;
                this.frame.style.height = '';
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductImagesSlider.prototype, "sliderPosition", {
        get: function () {
            return this.isVertical && !this.isMobile ? this.slider.offsetTop : this.slider.offsetLeft;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProductImagesSlider.prototype, "sliderNextPosition", {
        get: function () {
            var nextVisibleItem = this.allNotHiddenElements(this.slideItems)[this.scrolledItems];
            if (!nextVisibleItem) {
                return 0;
            }
            return this.isVertical && !this.isMobile ? nextVisibleItem.offsetTop : nextVisibleItem.offsetLeft;
        },
        enumerable: false,
        configurable: true
    });
    ProductImagesSlider.prototype.getTotalItems = function () {
        return this.allNotHiddenElements(this.slideItems).length;
    };
    Object.defineProperty(ProductImagesSlider.prototype, "slideIndexesForFormat", {
        get: function () {
            return this.allNotHiddenElements(this.slideItems).map(this.getElementSlideId);
        },
        enumerable: false,
        configurable: true
    });
    ProductImagesSlider.prototype.getSlideSiblings = function () {
        var slideList = this.slideIndexesForFormat;
        var activeSlideIndex = slideList.indexOf(this.activeSlideId);
        var prevSlides = slideList.slice(0, activeSlideIndex);
        var nextSlides = slideList.slice(activeSlideIndex + 1);
        var slidesQueue = __spreadArray(__spreadArray([], nextSlides, true), prevSlides, true);
        return {
            nextSlideId: slidesQueue[0],
            prevSlideId: slidesQueue[slidesQueue.length - 1],
        };
    };
    ProductImagesSlider.prototype.canBeSlided = function () {
        var MIN_SLIDES_AMOUNT_FOR_SLIDING = 2;
        return this.totalItems >= MIN_SLIDES_AMOUNT_FOR_SLIDING;
    };
    ProductImagesSlider.prototype.getElementSlideId = function (element) {
        var elementDataId = element.dataset.slideid || '0';
        return parseInt(elementDataId, 10);
    };
    ProductImagesSlider.prototype.allNotHiddenElements = function (elementList) {
        return elementList.filter(function (item) { return !item.classList.contains(ProductImagesSlider.HIDDEN_CLASSNAME); });
    };
    ProductImagesSlider.prototype.setImageUrl = function (imageElement) {
        if (!imageElement) {
            return;
        }
        if (imageElement.getAttribute('src') !== '') {
            return;
        }
        imageElement.src = imageElement.dataset.src || '';
    };
    ProductImagesSlider.HIDDEN_CLASSNAME = 'is-hidden';
    ProductImagesSlider.DISABLED_CLASSNAME = 'is-disabled';
    ProductImagesSlider.ACTIVE_CLASSNAME = 'active';
    ProductImagesSlider.MAIN_IMAGE_SELECTOR = '.js-product-img';
    ProductImagesSlider.MAIN_IMAGE_SOURCE_SELECTOR = '.js-product-img-source';
    ProductImagesSlider.MAIN_OVERLAY_IMAGE_SELECTOR = '.js-main-overlay-image';
    ProductImagesSlider.GALLERY_OVERLAY_IMAGE_SELECTOR = '.js-gallery-overlay-image';
    ProductImagesSlider.DOTS_SELECTOR = '.js-slider-dot';
    ProductImagesSlider.PREV_BUTTON_SELECTOR_MOBILE = '.js-prev-btn-mobile';
    ProductImagesSlider.NEXT_BUTTON_SELECTOR_MOBILE = '.js-next-btn-mobile';
    ProductImagesSlider.INNERPAGES_NOTE_TEXT_GENERAL = '.js-innerpages-note-text-general';
    ProductImagesSlider.INNERPAGES_NOTE_TEXT_DESIGNED = '.js-innerpages-note-text-designed';
    return ProductImagesSlider;
}(AbstractSlider_1.default));
exports.default = ProductImagesSlider;
